exports.buildSaveProfilePicturePayload = ({
    picFile,
    position,
    rotation,
    scale
}) => {

    return {
        picture: picFile,
        cropPosition: position,
        cropRotation: rotation,
        cropScale: scale
    };
};

exports.shouldClearProfilePictureOnSubmit = ({
    existingPicture,
    picFile,
    croppedPicture,
    picPreviewURL
}) => {

    return !existingPicture && !picFile && !croppedPicture && !picPreviewURL;
};

exports.buildClearProfilePicturePayload = () => {

    return {
        picture: null,
        cropPosition: { x: .5, y: .5 },
        cropRotation: 0,
        cropScale: 1
    };
};

exports.clearProfilePictureOnSubmitIfNeeded = async ({
    existingPicture,
    picFile,
    croppedPicture,
    picPreviewURL,
    saveProfilePicture
}) => {

    if (!exports.shouldClearProfilePictureOnSubmit({
        existingPicture,
        picFile,
        croppedPicture,
        picPreviewURL
    })) {
        return false;
    }

    await saveProfilePicture(exports.buildClearProfilePicturePayload());
    return true;
};

exports.buildFailedProfilePictureUploadValues = () => {

    return {
        picPreviewURL: ''
    };
};

exports.buildCloseCroppingValues = () => {

    return {
        cropPosition: { x: .5, y: .5 },
        cropRotation: 0,
        cropScale: 1,
        picFile: null
    };
};

exports.getProfileImageUploadFileFromEvent = (event) => {

    return event?.target?.files?.[0] || null;
};

exports.shouldProcessProfileImageUpload = (file) => {

    return !!file;
};

exports.getProcessedProfileImageFile = ({
    file,
    processedFile
}) => {

    return processedFile || file;
};
